module.exports = __webpack_public_path__ + "94f15a3cc6f68b0cc5a1a74eac4ab1b9.png";